import { AType, summon } from "@silversea-ssc/functional-support"
import { Occupancy } from "../occupancy"
import { SingleFareOptions } from "./single-fare-options"
import { CruiseCode } from "@ssc-booking/functional-support"
import { CruiseExpiration } from "../cruise-expiration"

export const FareOptionsResponse = summon((F) =>
    F.interface(
        {
            cruiseCode: CruiseCode(F),
            occupancy: Occupancy(F),
            options: F.nonEmptyArray(SingleFareOptions(F)),
            cruiseExpiration: CruiseExpiration(F),
        },
        "FareOptionsResponse",
    ),
)
export type FareOptionsResponse = AType<typeof FareOptionsResponse>
